import { createClient } from "@supabase/supabase-js";

const sbBase = "https://yfdjmmqisnldlslznukz.supabase.co";
const sbAPI = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlmZGptbXFpc25sZGxzbHpudWt6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDk1NzkzNzAsImV4cCI6MjAyNTE1NTM3MH0.9ctY3eExIdo7NRitrG1BXCvk1ud2DWmhIu9or2RgoZ8";

const sbURL = typeof window !== 'undefined'
  ? `${window.location.origin}/api/supabase`
  : sbBase;

export const supabase = createClient(sbURL, sbAPI);